// pages/AgendaPage.js o donde desees usarlo
import React from 'react';
import { Box } from '@mui/material';
import TaxiTiposServicios from '../../components/administration/taxiServiceTypes/TaxiServicesTypesDashboard';

const TaxiTiposServiciosPage = () => {
    return (
        <Box sx={{ p: 2 }}>
            <TaxiTiposServicios
                onReorder={(newOrder) => {
                    console.log('Nuevo orden de grupos de servicios de taxi:', newOrder);
                }}
            />
        </Box>
    );
};

export default TaxiTiposServiciosPage;
